import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Join class names, letting later Tailwind utilities win over earlier ones in
 * the same group.
 *
 * `clsx` alone concatenates, so `cn('p-2', 'p-4')` would emit both and the
 * winner would depend on stylesheet order rather than call order — which makes
 * a `className` prop unable to reliably override a component's own padding.
 * `twMerge` resolves the conflict to the last one written.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
